"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var factory_1 = require("../../factory");
function getHardwareInfo() {
    return new Promise(function (resolve, reject) {
        var deviceMemory = (navigator.deviceMemory !== undefined) ? navigator.deviceMemory : 0;
        resolve({
            'videocard': getVideoCard(),
            'architecture': getArchitecture(),
            'deviceMemory': deviceMemory.toString() || 'undefined'
        });
    });
}
/**
 * @see Credits: https://stackoverflow.com/a/49267844
 */
function getVideoCard() {
    var _a;
    var canvas = document.createElement('canvas');
    var gl = (_a = canvas.getContext('webgl')) !== null && _a !== void 0 ? _a : canvas.getContext('experimental-webgl');
    if (gl && 'getParameter' in gl) {
        return {
            vendor: (gl.getParameter(gl.VENDOR) || '').toString(),
            renderer: (gl.getParameter(gl.RENDERER) || '').toString(),
        };
    }
    return "undefined";
}
function getArchitecture() {
    var f = new Float32Array(1);
    var u8 = new Uint8Array(f.buffer);
    f[0] = Infinity;
    f[0] = f[0] - f[0];
    return u8[3];
}
(0, factory_1.includeComponent)('hardware', getHardwareInfo);
//# sourceMappingURL=hardware.js.map